import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Redirect, Route, Switch } from 'react-router-dom';
import { withStyles } from '@material-ui/core';

import CollectionContainer from './dashboard/containers/collection-container';
import InitPendoScript from './common/components/init-pendo-script';
import ModalContainer from './modal/modal-container';
import NavBar from './common/components/nav-bar';
import PrivateRoute from './common/private-route';
import ReportsContainer from './reports/containers/reports-container';
import RightPaneContainer from './right-pane/right-pane-container';
import SideNav from './common/components/side-nav';
import SnackbarContainer from './snackbar/snackbar-container';

import {
    RIGHT_PANE_WIDTH,
    SIDE_NAV_WIDTH,
} from './common/constants/ui-options';
import { RIGHT_PANE_VARIANTS } from './right-pane/constants';

const styles = theme => ( {
    appBarSpacer: {
        '@media print': {
            height: '0px !important'
        },
        height: SIDE_NAV_WIDTH,
    },
    content: {
        flexGrow: 1,
    },
    main: {
        '@media print': {
            display: 'block',
            marginLeft: '0px !important',
        },
        alignItems: 'stretch',
        backgroundColor: theme.palette.grey[200],
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        justifyContent: 'center',
        marginLeft: SIDE_NAV_WIDTH
    },
    rightPaneIsClosed: {
        transition: theme.transitions.create( 'margin', {
            duration: theme.transitions.duration.leavingScreen,
            easing: theme.transitions.easing.sharp,
        } ),
    },
    rightPaneIsOpen: {
        marginRight: RIGHT_PANE_WIDTH,
        transition: theme.transitions.create( 'margin', {
            duration: theme.transitions.duration.enteringScreen,
            easing: theme.transitions.easing.easeOut,
        } ),
    }
} );

export class EfdPrivateRoutes extends Component{
    render(){
        const {
            appItems,
            classes,
            endUserAuthApi,
            hasNewFeatureVisibility,
            isExperimental,
            logout,
            navBarMessage,
            rightPaneIsOpen,
            rightPaneVariant,
            sideNavItems,
            switchSideNavItems,
            userInfo,
        } = this.props;
        return (

            <React.Fragment>
                <NavBar
                    appItems={appItems}
                    hasNewFeatureVisibility={hasNewFeatureVisibility}
                    isExperimental={isExperimental}
                    navBarMessage={navBarMessage}
                    onLogout={logout}
                    userInfo={userInfo}
                />
                <SideNav
                    isExperimental={isExperimental}
                    sideNavItems={sideNavItems}
                    switchSideNavItems={switchSideNavItems}
                />
                <main
                    className={cx( classes.main, {
                        [classes.rightPaneIsClosed]: !rightPaneIsOpen,
                        [classes.rightPaneIsOpen]: rightPaneIsOpen && rightPaneVariant === RIGHT_PANE_VARIANTS['standard']
                    } )}
                >
                    <div className={classes.appBarSpacer} />
                    <div className={classes.content}>
                        <Switch>
                            <PrivateRoute
                                component={ReportsContainer}
                                path="/reports"
                            />
                            {
                                isExperimental &&
                                    ( <PrivateRoute
                                        component={CollectionContainer}
                                        path="/collections"
                                    /> )
                            }
                            <Route
                                component={() => <Redirect to="/reports" />}
                                exact
                                {...this.props}
                            />
                        </Switch>
                    </div>
                </main>
                <RightPaneContainer />
                <ModalContainer />
                <SnackbarContainer />
                <iframe
                    frameBorder="0"
                    height="0"
                    hidden
                    id="authiframe"
                    marginHeight="0"
                    marginWidth="0"
                    src={`${endUserAuthApi}/v1/token/refreshscript`}
                    style={{ border: '0px', display: 'none', visibility: 'hidden' }}
                    title="refreshscript"
                    width="0"
                />
                <InitPendoScript />
            </React.Fragment>
        );
    }
}

EfdPrivateRoutes.propTypes = {
    appItems: PropTypes.array,
    classes: PropTypes.object.isRequired,
    endUserAuthApi: PropTypes.string.isRequired,
    hasNewFeatureVisibility: PropTypes.bool.isRequired,
    initialDataHasLoaded: PropTypes.shape( {
        done: PropTypes.bool,
        numberOfRequests: PropTypes.number,
    } ),
    isExperimental: PropTypes.bool.isRequired,
    logout: PropTypes.func.isRequired,
    navBarMessage: PropTypes.string,
    rightPaneIsOpen: PropTypes.bool,
    rightPaneVariant: PropTypes.string,
    sideNavItems: PropTypes.array,
    switchSideNavItems: PropTypes.func.isRequired,
    userInfo: PropTypes.object,
};

export default( withStyles( styles )( EfdPrivateRoutes ) );
